import { useEffect, useRef, useState } from "react";

const useComponentClickOutside = () => {
  const [isComponentVisible, setIsComponentVisible] = useState(false);
  const wrapRef = useRef(null);

  const toggleChild = () => setIsComponentVisible((s) => !s);

  const handleClickOutside = (e) => {
    if (wrapRef.current && !wrapRef.current.contains(e.target)) {
      setIsComponentVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside, true);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside, true);
    };
  });

  return { wrapRef, toggleChild, isComponentVisible };
};

export default useComponentClickOutside;
